import { useEffect, useState } from "react"
import {TWILLIO_CONNECT_PPT_ENDPOINT} from '../../../lib/consts';

export type TwilioConnectProps = {
  token: string
  onConnect: () => unknown
}

export default function TwilioConnect({
  onConnect, token
}: TwilioConnectProps): JSX.Element {
  const [childWindow, setChildWindow] = useState<Window | null>(null)

  useEffect(() => {
    if (!childWindow) {
       return
    }
    const interval = setInterval(() => {
      if (childWindow.closed) {
        clearInterval(interval)
        setChildWindow(null)
        console.log("*** Window was closed!")
        // todo add side effect of window closing
        if (onConnect) {
          onConnect()
        }
      }
    }, 500)
    return () => clearInterval(interval)
  }, [childWindow, onConnect])

  const handleChildWindowOpen = (window: Window | null) => {
    setChildWindow(window)
  }

  return (
    <div className={"box-content w-3/4 p-4" + " flex flex-col items-start"}>
      <p>
        Twilio is a 3rd Party service that allows Pipeline Pro Tools to use
        custom phone numbers for SMS and Voice lead capture. We've recently made
        improvements to make setup easier!
      </p>
      <ol className="p-4">
        <li className="mt-4">
          1. Sign up for a Twilio Account. You will need to verify your account
          with Twilio.
        </li>
        <li className="mt-4">
          2. Add a payment method, and some account credit account credit to use
          custom phone numbers.
          <aside className="text-center p-2 bg-ppt-blue-900 text-ppt-caution mx-4">
            IMPORTANT: Don't purchase a phone number in the Twilio Dashboard,
            you'll do that in the next step.
          </aside>
        </li>
        <li className="mt-4">
          3. Make sure you are logged into Twilio in a different window.
        </li>
        <li className="flex flex-row items-center mt-4">
          4. When those steps are done, just click this button:
          <TwilioConnectButton
            onChildWindowOpen={handleChildWindowOpen}
            token={token}
          ></TwilioConnectButton>
        </li>
      </ol>
    </div>
  )
}


function twilioConnectUrl(state: string) {
  return `${TWILLIO_CONNECT_PPT_ENDPOINT}?state=${state}`
}

type TwilioConnectButtonProps = {
  token: string
  onChildWindowOpen: (window: Window | null) => unknown
}

function TwilioConnectButton({
  token, onChildWindowOpen
}: TwilioConnectButtonProps): JSX.Element {
  const handleClick = () => {
    const childWindow = window.open(
      twilioConnectUrl(token),
      "Connect to Twilio...",
      "height=500,width=1000,menubar=0,toolbar=0,location=0"
    );
    onChildWindowOpen(childWindow);
  };

  return <button id="twilio-connect-button" onClick={handleClick}></button>;
};